// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chat-clear"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.5 3L21.5 3V17H6.5L2.5 20.5L2.5 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.5 3L21.5 3V17H6.5L2.5 20.5L2.5 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.8287 7.17157L12.0003 10M12.0003 10L9.17188 12.8284M12.0003 10L14.8287 12.8284M12.0003 10L9.17188 7.17157","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChatClearIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-clear',
    ref,
    icon: element,
  },
));

ChatClearIcon.displayName = 'ChatClearIcon';

export default ChatClearIcon;
